export const LOCAL_RXDB_CACHE_VERSION = 2;

export const currentLocalCacheVersionValue = String(LOCAL_RXDB_CACHE_VERSION);

export const localCacheVersionKey = (userId: string) =>
  `clew-rxdb-cache-version:${userId}`;

export const shouldResetForLocalCacheVersion = (
  storedVersion: null | string,
): boolean => storedVersion !== currentLocalCacheVersionValue;

export const readLocalCacheVersion = (userId: string): null | string => {
  try {
    return localStorage.getItem(localCacheVersionKey(userId));
  } catch {
    return currentLocalCacheVersionValue;
  }
};

export const writeCurrentLocalCacheVersion = (userId: string): void => {
  try {
    localStorage.setItem(
      localCacheVersionKey(userId),
      currentLocalCacheVersionValue,
    );
  } catch {
    // localStorage may be unavailable; the DB6 retry path remains as fallback.
  }
};

export const isRxSchemaMismatchError = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  'code' in error &&
  (error as { code?: unknown }).code === 'DB6';
